// frontend/src/components/PrivateRoute/PrivateRoute.js

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../../UserContext';

function PrivateRoute({ children }) {
  const { user } = useContext(UserContext);

  if (!user) {
    // Inte inloggad, omdirigera till inloggningssidan
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default PrivateRoute;
